import * as React from 'react'

import { observer } from 'mobx-react'

import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  title: string
  isShown: boolean
  onHide: () => void
  onApply: () => void
}

@observer
export default class EntityDateMoveConfirm extends React.Component<IProps> {
  public render() {
    const { isShown, title, onHide, onApply } = this.props

    return (
      <ConfirmDialog
        isOpen={isShown}
        title={title}
        onCancelClicked={onHide}
        onDoneClicked={onApply}
        doneTitle={Localization.translator.change_verb}
      />
    )
  }
}
